import {useEvent} from 'Event/EventProvider'
import React from 'react'
import CircularProgress from '@material-ui/core/CircularProgress'

import Button from 'lib/ui/Button'
import {useToggle} from 'lib/toggle'
import {OntraportTag} from 'organization/Event/Services/Apps/Ontraport/Config/Tags'
import AutocompleteTags, {
  CreateNewTagDialog,
} from 'organization/Event/Services/Apps/Ontraport/Config/Tags/AutocompleteTags'
import IntegrationTagField from 'organization/Event/DashboardConfig/IntegrationTagField'

export default function OntraportTagInput(props: {
  onChange: (tag: OntraportTag | null) => void
  value?: OntraportTag | null
  disabled?: boolean
  inputVariant?: 'filled' | 'standard' | 'outlined'
  label?: string
}) {
  const {value, onChange, label, inputVariant} = props

  const {event} = useEvent()
  const {flag: showCreateForm, toggle: toggleShowCreateForm} = useToggle()
  if (!event.has_ontraport) {
    return null
  }

  const handleOnCreate = (newTag: OntraportTag) => {
    toggleShowCreateForm()
    onChange(newTag)
  }

  return (
    <>
      <IntegrationTagField>
        <AutocompleteTags
          inputLabel={label ?? 'Ontraport Tag'}
          value={value}
          onChange={onChange}
          inputVariant={inputVariant ?? 'outlined'}
          disabled={props.disabled ?? false}
          endAdornment={(loading, arrow) =>
            loading ? (
              <>
                <CircularProgress color="inherit" size={20} />
              </>
            ) : (
              <>
                {arrow}
                <Button
                  color="primary"
                  size="large"
                  aria-label="create tag"
                  onClick={toggleShowCreateForm}
                >
                  Create new tag
                </Button>
              </>
            )
          }
        />
      </IntegrationTagField>
      <CreateNewTagDialog
        visible={showCreateForm}
        onClose={toggleShowCreateForm}
        onCreate={handleOnCreate}
      />
    </>
  )
}
